module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("O tamanho das imagens pode impactar diretamente na performance e tempo de carregamento do aplicativo.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.id_pais.$error
    }
  }, [_c('label', [_vm._v("País*")]), _vm._v(" "), _c('select-api', {
    attrs: {
      "endpoint": '/pais/pesquisa',
      "opt-text": 'nome',
      "select-option": true
    },
    model: {
      value: (_vm.model.id_pais),
      callback: function($$v) {
        _vm.$set(_vm.model, "id_pais", $$v)
      },
      expression: "model.id_pais"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.id_integradora.$error
    }
  }, [_c('label', [_vm._v("Integradora*")]), _vm._v(" "), _c('select-api', {
    attrs: {
      "endpoint": '/integradora/pesquisa',
      "opt-text": 'nome',
      "select-option": true
    },
    model: {
      value: (_vm.model.id_integradora),
      callback: function($$v) {
        _vm.$set(_vm.model, "id_integradora", $$v)
      },
      expression: "model.id_integradora"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.nome.$error
    }
  }, [_c('label', [_vm._v("Nome*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.nome),
      expression: "model.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.model.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-danger': _vm.$v.model.codigo.$error
    }
  }, [_c('label', [_vm._v("Código*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.codigo),
      expression: "model.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.model.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "codigo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Telefone SMS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.telefoneSms),
      expression: "model.telefoneSms"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.model.telefoneSms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "telefoneSms", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 align-self-center"
  }, [_c('label', [_vm._v("Ativo")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input-toggle', {
    attrs: {
      "value": _vm.model.ativo
    },
    model: {
      value: (_vm.model.ativo),
      callback: function($$v) {
        _vm.$set(_vm.model, "ativo", $$v)
      },
      expression: "model.ativo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Carrier")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.carrier),
      expression: "model.carrier"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.model.carrier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "carrier", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12",
    class: {
      'dropdown-has-error': _vm.$v.model.tipoAutenticacao.$error
    }
  }, [_c('label', [_vm._v("Tipo Autenticação*")]), _vm._v(" "), _c('Select2', {
    attrs: {
      "placeholder": "Selecione",
      "options": _vm.tiposAutenticacao
    },
    model: {
      value: (_vm.model.tipoAutenticacao),
      callback: function($$v) {
        _vm.$set(_vm.model, "tipoAutenticacao", $$v)
      },
      expression: "model.tipoAutenticacao"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('label', [_vm._v("Campos obrigatórios")]), _vm._v(" "), _c('Select2', {
    attrs: {
      "multiple": true,
      "options": _vm.camposObrigatorios,
      "is-array": true
    },
    model: {
      value: (_vm.model.camposRegistro),
      callback: function($$v) {
        _vm.$set(_vm.model, "camposRegistro", $$v)
      },
      expression: "model.camposRegistro"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Cor")]), _vm._v(" "), _c('chrome-picker', {
    model: {
      value: (_vm.corObjeto),
      callback: function($$v) {
        _vm.corObjeto = $$v
      },
      expression: "corObjeto"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Mensagem Cancelamento")]), _vm._v(" "), _c('dw-textarea', {
    attrs: {
      "maxlength": "250"
    },
    model: {
      value: (_vm.model.mensagemCancelamento),
      callback: function($$v) {
        _vm.$set(_vm.model, "mensagemCancelamento", $$v)
      },
      expression: "model.mensagemCancelamento"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Mensagem Número Cancelado")]), _vm._v(" "), _c('dw-textarea', {
    attrs: {
      "maxlength": "250"
    },
    model: {
      value: (_vm.model.mensagemNumeroCancelado),
      callback: function($$v) {
        _vm.$set(_vm.model, "mensagemNumeroCancelado", $$v)
      },
      expression: "model.mensagemNumeroCancelado"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Mensagem Número Inválido")]), _vm._v(" "), _c('dw-textarea', {
    attrs: {
      "maxlength": "250"
    },
    model: {
      value: (_vm.model.mensagemNumeroInvalido),
      callback: function($$v) {
        _vm.$set(_vm.model, "mensagemNumeroInvalido", $$v)
      },
      expression: "model.mensagemNumeroInvalido"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Mensagem Não Assinante")]), _vm._v(" "), _c('dw-textarea', {
    attrs: {
      "maxlength": "250"
    },
    model: {
      value: (_vm.model.mensagemNaoAssinante),
      callback: function($$v) {
        _vm.$set(_vm.model, "mensagemNaoAssinante", $$v)
      },
      expression: "model.mensagemNaoAssinante"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Mensagem Sem Saldo")]), _vm._v(" "), _c('dw-textarea', {
    attrs: {
      "maxlength": "250"
    },
    model: {
      value: (_vm.model.mensagemSemSaldo),
      callback: function($$v) {
        _vm.$set(_vm.model, "mensagemSemSaldo", $$v)
      },
      expression: "model.mensagemSemSaldo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Url Verificação")]), _vm._v(" "), _c('dw-textarea', {
    attrs: {
      "maxlength": "250"
    },
    model: {
      value: (_vm.model.urlVerificacao),
      callback: function($$v) {
        _vm.$set(_vm.model, "urlVerificacao", $$v)
      },
      expression: "model.urlVerificacao"
    }
  }), _vm._v(" "), _c('small', [_vm._v("Pode colocar as tags {telefone} ou {codigo} para substituir pelo valor do usuário logado.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Url Cancelamento")]), _vm._v(" "), _c('dw-textarea', {
    attrs: {
      "maxlength": "250"
    },
    model: {
      value: (_vm.model.urlCancelamento),
      callback: function($$v) {
        _vm.$set(_vm.model, "urlCancelamento", $$v)
      },
      expression: "model.urlCancelamento"
    }
  }), _vm._v(" "), _c('small', [_vm._v("Pode colocar as tags {telefone} ou {codigo} para substituir pelo valor do usuário logado.")])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('file-image', {
    attrs: {
      "label": 'Imagem',
      "arquivo": _vm.model.arquivo
    },
    model: {
      value: (_vm.imagem),
      callback: function($$v) {
        _vm.imagem = $$v
      },
      expression: "imagem"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3",
    class: {
      'has-danger': _vm.$v.produto.nome.$error
    }
  }, [_c('label', [_vm._v("Nome*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.produto.nome),
      expression: "produto.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.produto.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.produto, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-danger': _vm.$v.produto.codigoProduto.$error
    }
  }, [_c('label', [_vm._v("Código Produto*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.produto.codigoProduto),
      expression: "produto.codigoProduto"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.produto.codigoProduto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.produto, "codigoProduto", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-danger': _vm.$v.produto.codigoProdutoIntegradora.$error
    }
  }, [_c('label', [_vm._v("Código Produto Integradora*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.produto.codigoProdutoIntegradora),
      expression: "produto.codigoProdutoIntegradora"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.produto.codigoProdutoIntegradora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.produto, "codigoProdutoIntegradora", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Adicionar")])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-10",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-md"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.model.produtos), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": 'Nome'
      }
    }, [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": 'Cód. Prod.'
      }
    }, [_vm._v(_vm._s(item.codigoProduto))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": 'Cód. Inte.'
      }
    }, [_vm._v(_vm._s(item.codigoProdutoIntegradora))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.remove(index)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'list-carrier'
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fas fa-menu"
  }), _vm._v(" Operadora\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v("\n                            O tamanho máximo e indicado para a\n                            "), _c('strong', [_vm._v("Imagem")]), _vm._v(" é de\n                            "), _c('strong', [_vm._v("300kb")]), _vm._v(".\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fas fa-box"
  }), _vm._v(" Produtos\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Cód.")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Cód. Prod.")]), _vm._v(" "), _c('th', [_vm._v("Cód. Inte.")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-220359a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/carrier/Form.vue
// module id = 837
// module chunks = 1